import { API } from "src/server/api";
import { useState, useEffect } from "react";
import { useAuth } from "src/hooks/use-auth";
import { useRouter } from "src/hooks/use-router";
import { getDecryptedItem, setEncryptedItem } from "src/server/crypto";
import { decodeToken } from "src/libs/jwt";

const STORAGE_KEY = "__jlx_AX929423189B";

const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const auth = useAuth();
  const router = useRouter();

  useEffect(() => {
    const resInterceptor = (response) => {
      return response;
    };

    const errInterceptor = async (error) => {
      const originalRequest = error.config;

      // Don't intercept refresh-token endpoint to avoid infinite loop
      if (originalRequest.url?.includes("auth/refresh-token")) {
        await auth.signOut();
        router.replace("/auth/login");
        return Promise.reject(error);
      }

      if (
        (error.response?.status === 401 || error.response.status === 403) &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        try {
          const accessToken = getDecryptedItem(STORAGE_KEY);
          const payload = decodeToken(accessToken);

          const response = await API.post("auth/refresh-token", payload);

          const newToken = response.data.token;
          setEncryptedItem(STORAGE_KEY, newToken);

          originalRequest.headers["Authorization"] = "Bearer " + newToken;
          return API(originalRequest);
        } catch (refreshError) {
          console.error("Refresh token expired:", refreshError);
          await auth.signOut();
          router.replace("/auth/login");
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    };

    const interceptor = API.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => API.interceptors.response.eject(interceptor);
  }, [router, auth]);

  return isSet && children;
};

export { AxiosInterceptor };
